var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-card-text',[_c('p',{staticClass:"font-weight-bold",attrs:{"id":"report-overview-date"}},[_vm._v(" "+_vm._s(_vm.dateRange))]),_c('p',{staticClass:"font-weight-bold",attrs:{"id":"report-overview-cost"}},[_vm._v(" $"+_vm._s(new Intl.NumberFormat().format(_vm.cost)))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }